import React from 'react'
import { Header } from '../../../components/common/Header'

import '../index.less'
import { ModalRecoveryKey } from '../../../components/user/ModalRecoveryKey'
import { PatientsDirectory } from '../../../components/patients/PatientsDirectory'

export default function PatientsPage() {
  return (
    <div className="Dashboard">
      <Header />
      <PatientsDirectory />
      <ModalRecoveryKey />
    </div>
  )
}
